export default __webpack_public_path__ + "static/page-404-7a8975d74074dc07e920cf03172acad2.svg";